import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19e724cb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=19e724cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e724cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e724cb')) {
      api.createRecord('19e724cb', component.options)
    } else {
      api.reload('19e724cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19e724cb&scoped=true&", function () {
      api.rerender('19e724cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/Sidebar/index.vue"
export default component.exports